"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _reactIntl = require("react-intl");
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _ModalHeader2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalHeader"));
var _Illustration = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Illustration"));
var _context = require("../../../../../services/log/context");
var _ChevronForward2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ChevronForward"));
var _AccountCircle2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/AccountCircle"));
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _Stack2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Separator = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Separator"));
var _events = require("../../../consts/events");
var _usePublishContinueAsGuestClicked = _interopRequireDefault(require("../../../consts/events/business/usePublishContinueAsGuestClicked"));
var _jsxRuntime = require("react/jsx-runtime");
var _ModalHeader, _AccountCircle, _FormattedMessage, _Stack, _ChevronForward, _FormattedMessage2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RequiredLoginScreen = _ref => {
  let {
    onHandleToIntro,
    onHandleContinueAsGuest
  } = _ref;
  const {
    log
  } = (0, _context.useLog)();
  const publishContinueAsGuestClicked = (0, _usePublishContinueAsGuestClicked.default)();
  const handleOnSignIn = (0, _react.useCallback)(() => {
    log(_events.REQUIRED_LOGIN_SIGN_IN_CLICKED, {});
    onHandleToIntro();
  }, [log, onHandleToIntro]);
  const handleContinueAsGuest = (0, _react.useCallback)(() => {
    publishContinueAsGuestClicked();
    onHandleContinueAsGuest();
  }, [publishContinueAsGuestClicked, onHandleContinueAsGuest]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [_ModalHeader || (_ModalHeader = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalHeader2.default, {
      title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.required_login.header"
      }),
      illustration: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Illustration.default, {
        name: "Login",
        size: "extraSmall"
      }),
      description: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.required_login.description"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ModalSection.default, {
      dataTest: "MagicLogin-RequiredLogin",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        fullWidth: true,
        spaceAfter: "medium",
        iconLeft: _AccountCircle || (_AccountCircle = /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccountCircle2.default, {
          ariaHidden: true
        })),
        type: "primary",
        onClick: handleOnSignIn,
        dataTest: "MagicLogin-SignInButton",
        centered: true,
        children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.sign_in"
        }))
      }), _Stack || (_Stack = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack2.default, {
        direction: "row",
        align: "center",
        spaceAfter: "medium",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          as: "span",
          type: "primary",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "common.or"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator.default, {})]
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack2.default, {
        align: "center",
        direction: "column",
        spaceAfter: "small",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
          asComponent: "button",
          onClick: handleContinueAsGuest,
          type: "secondary",
          size: "normal",
          iconRight: _ChevronForward || (_ChevronForward = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronForward2.default, {})),
          dataTest: "MagicLogin-GuestTextLink",
          children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.required_login.text_link.guest"
          }))
        })
      })]
    })]
  });
};
var _default = exports.default = RequiredLoginScreen;